export default {
  ON_SITE: 'onSite',
  PRE_CUT: 'preCut',
  ELEMENTS: 'elements',
  MODULES: 'modules',
  ALL: 'all'
};
